/**
 * Overview API - Aggregated data for multiple pages
 */

import { apiClient } from "./client";
import type { OverviewResponse, OverviewQuickStats } from "./types";

/**
 * Get aggregated overview data
 */
export async function getOverview(
  zone: string = "NORD"
): Promise<OverviewResponse> {
  return apiClient.get<OverviewResponse>(
    `/api/v1/overview?zone=${zone}`
  );
}

/**
 * Get quick stats (6 key metrics)
 */
export async function getOverviewQuickStats(
  zone: string = "NORD"
): Promise<OverviewQuickStats> {
  return apiClient.get<OverviewQuickStats>(
    `/api/v1/overview/quick-stats?zone=${zone}`
  );
}
